import React from 'react';
import {
  accentButtonBackground,
  darkModeBorder,
  lightModeBorder,
} from "../util/style";
import { useAppContext } from "./AppContext";

const MarketStatus: React.FC = () => {
  const {
    darkMode,
    getFont,
    blink,
    marketStatus,
    ignoreTokenLimit,
    setIgnoreTokenLimit,
    isMarketTime,
  } = useAppContext() || {};

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: `1px solid ${darkMode ? darkModeBorder : lightModeBorder}`,
          padding: "1px 4px 1px 4px",
          borderRadius: "2px",
          width: "fit-content",
        }}
      >
        <div
          style={{
            backgroundColor: marketStatus?.color,
            height: "6px",
            width: "6px",
            borderRadius: "50%",
            transform: blink ? "scale(1.7)" : "scale(1)",
            transition: "all 0.15s ease",
            marginRight: "3px",
          }}
        ></div>
        <div
          style={{
            fontSize: getFont?.(10),
            marginTop: "1px",
          }}
        >
          {marketStatus?.title}
        </div>
      </div>
      {!isMarketTime && (
        <div
          style={{
            fontSize: getFont?.(10),
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            width: "fit-content",
            padding: "0 3px 0 0",
          }}
          onClick={() => {
            setIgnoreTokenLimit?.((prev: boolean) => !prev);
          }}
          className="hoverWatchlistBackground"
        >
          <input
            type="checkbox"
            checked={ignoreTokenLimit}
            readOnly
            style={{
              cursor: "pointer",
              accentColor: accentButtonBackground,
              margin: "0 2px 0 0",
              transform: "scale(0.75)",
            }}
          />
          <div>Update&nbsp;24/7</div>
        </div>
      )}
    </div>
  );
};

export default MarketStatus;
